import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import Footer from '../components/Footer';
import staticlogo from '../assets/images/bg_blue.svg';
import helpcenterimage from '../assets/images/logo_icon_white.svg';
import config from '../config/config';

const TransparencyCenterSingle = () => {
  const { id } = useParams(); // Extract id from URL parameters
  const [title, setTitle] = useState('Loading...');
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        // Make sure the query parameter is correctly formatted
        const response = await axios.get(`${config.baseURL}/safety-transparency-links`, {
          params: { id }
        });

        console.log('API Response:', response.data); // Debug API response

        if (response.data.success) {
          const pageContent = response.data.data;
          setTitle(pageContent.title || 'No Title'); // Handle empty titles
          setContent(pageContent.content || 'No Content'); // Handle empty content
        } else {
          setTitle('Content Not Found');
          setContent('The content you are looking for does not exist.');
        }
      } catch (error) {
        console.error('Failed to fetch content:', error);
        setTitle('Error');
        setContent('Failed to fetch content. Please try again later.');
      } finally {
        setLoading(false); // Set loading to false when done
      }
    };

    fetchContent();
  }, [id]);

  return (
    <div>
      <div className="static_header_inner">
        <div className="container-fluid">
          <div className="col-md-12">
            <div className="static_header_logo">
              <Link to="/">
                <img src={staticlogo} alt="Static Logo" /> PatreonPass
              </Link>
            </div>
          </div>
        </div>
      </div>

      <section id="help_search" className="help_search help_center_area">
        <div className="help_center">
          <img src={helpcenterimage} alt="Help Center" />
        </div>
        <div className="container">
          <div className="row">
            <div className="help_search_block">
              <h2 className="help_title">{title}</h2>
            </div>
          </div>
        </div>
      </section>

      <section className="inner_static">
        <div className="container">
          <div className="row">
            <div className="page_content_static_help single_trans">
              {loading ? (
                <p>Loading content...</p>
              ) : error ? (
                <p>{error}</p>
              ) : (
                <div dangerouslySetInnerHTML={{ __html: content }} />
              )}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TransparencyCenterSingle;
